<sirius-container>
    @if (logo) {
        <img
            class="sir-logo"
            data-cy="footer-simple-logo"
            [src]="logo.url"
            alt="Universal Robots" />
    }
    <div class="sir-info-container">
        <div class="sir-legal-container">
            <span data-cy="footer-simple-text">© {{ currentYear }} Universal Robots A/S</span>
            <ul class="sir-legal-links" data-cy="footer-simple-legal-links">
                @for (legalLink of footer.legalLinks; track legalLink.link.href) {
                    <li>
                        <a
                            siriusButton
                            [href]="legalLink.link.href"
                            [title]="legalLink.link.title"
                            [rel]="legalLink.link.rel"
                            [buttonText]="legalLink.link.title"
                            [size]="'none'"
                            [buttonType]="'linkstyle'"></a>
                    </li>
                }
            </ul>
        </div>
        <ul class="sir-social-media-links" data-cy="footer-simple-social-media-links">
            @for (soMeLink of socialMediaLinks; track soMeLink.link.href) {
                @if (soMeLink.icon) {
                    <li>
                        <a
                            [href]="soMeLink.link.href"
                            [title]="soMeLink.link.title"
                            [rel]="soMeLink.link.rel"
                            [target]="soMeLink.link.target">
                            <sirius-icon [name]="soMeLink.icon"></sirius-icon>
                        </a>
                    </li>
                }
            }
        </ul>
    </div>
</sirius-container>
